import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { faEdit, faBatteryThreeQuarters } from '@fortawesome/free-solid-svg-icons';
import VentBlock from '../widgets/ventblock';
import ControlBlock from '../widgets/controlblock';
import FourSet from '../widgets/fourset';
import Charts from '../widgets/charts';
import StatsImg from '../widgets/statsimg';
import { useWindowDimensions } from '../widgets/WindowsDimensionProvider';


export default function Ventilator() {
  const [loadA, setLoadA] = useState(false);
  const [time, setTime] = useState();
  const { width } = useWindowDimensions();
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadA(true)
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    var currentTime = moment().format('h:mm A');
    setTime(currentTime);
  }, []);

  return (
    <Wrap>
      <ScreenWrap>
        <Top>
          <Left>
            {time}
          </Left>
          <Right>
            <FontAwesomeIcon icon={faBatteryThreeQuarters} />
          </Right>
        </Top>
        <Middle>
          <MLeft>
            <VentBlock
              title="PPeaks"
              count="26"
              two="20"
              three="5"
              four="cmH20"
            />
            <VentBlock
              title="ExpMinVol"
              count="10.2"
              two="14"
              three="4.0"
              four="l/min"
            />
            <VentBlock
              title="VTE"
              count="380"
              two="850"
              three="Off"
              four="ml"
            />
            <VentBlock
              title="fTotal"
              count="21"
              two="35"
              three="8"
              four="b/min"
            />
          </MLeft>
          <MCenter>
            <Charts />
            <StatsImg />
          </MCenter>
          <MRight>
            <ControlBlock />
            <FourSet />
          </MRight>
        </Middle>
      </ScreenWrap>
      {loadA && width < 426 && (
        <OnLoad onClick={() => { setLoadA(false) }}>
          <Message>Turn your device to landscape mode to view full ventilator</Message>
        </OnLoad>
      )}
    </Wrap>
  )
}
const Message = styled.div`
  display: flex;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 20px;

`;
const opac = keyframes`
  from {
    background-color: rgba(0,0,0,0);
  }
  to {
    background-color: rgba(0,0,0,0.6);
  }
`;
const OnL = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 3;
  color: white;
  background-color: rgba(0,0,0,0.6);

`;
const OnLoad = styled(OnL)`
transition: all 0.2s linear;
  animation: ${opac} 0.2s linear;
`;

const GridSetup = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-gap: 10px;
  overflow: hidden;
`;
const MCenter = styled(GridSetup)`
  grid-template-rows: 1fr 1fr;
`;
const MLeft = styled(GridSetup)`
    grid-template-rows: 1fr 1fr 1fr 1fr;
`;
const MRight = styled(GridSetup)`
    grid-template-rows: 3fr 1fr;
`;

const Middle = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-gap: 10px;
  padding: 0 20px 20px 20px;
  height: 100%;
      @media screen and (max-width: 823px) and (orientation: landscape) {
      overflow: hidden;
      padding: 0 10px 10px;
      grid-gap: 5px;
    }
`;
const Left = styled.div`
    font-size: 12px;
`;
const Right = styled.div``;
const Top = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
      @media screen and (max-width: 823px) and (orientation: landscape) {
      padding: 10px 20px;
    }
`;

const Wrap = styled.div`
  margin: 20px auto;
  width: 1200px;
  height: 675px;
  overflow: hidden;
  user-select: none;
  @media screen and (max-width: 823px) and (orientation: landscape) {
      width: 100%;
      margin: 0;
    }
`;

const ScreenWrap = styled.div`
  color: white;
  flex-direction: column;
  background-color: #16223c;
  display: flex;
  border-radius: 30px;
  height: 100%;
  width: 100%;
  overflow: hidden;
    @media screen and (max-width: 823px) and (orientation: landscape) {
      border-radius: 0;
    }
`;
